import {AbstractEvent} from "@/modules/base/events";
import {Terrace} from "@/modules/stadium/entity";

export class BeforeEntranceFeeChangeEvent extends AbstractEvent {
  constructor(
    public terrace: Terrace,
    public oldFee: number,
    public newFee: number,
  ) {
    super();
  }
}